import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationError, getValidationErrors, mapErrors } from 'icreate/common/validators';

@Component({
    selector: 'app-input-with-error',
    templateUrl: './input-with-error.component.html',
    styleUrls: ['./input-with-error.component.css'],
    standalone: false,
})
export class InputWithErrorComponent implements OnChanges {
    @Input() inputValue;
    @Input() legend: string;
    @Input() propertyName: string;
    @Input() validatorFunction;
    @Input() inputHasErrors: boolean = false;
    @Input() otherValidationErrors: string;
    @Input() maxlength: number = 20;
    @Input() dark: boolean = false;
    @Input() icon: string;
    @Input() placeholder: string;
    @Input() removeBackground: boolean = false;
    @Input() disabledInput: boolean = false;
    @Input() showLegend: boolean = true;
    @Input() isNumberInput: boolean = false;
    @Input() unitText: string;
    @Input() customHeight: string;

    @Output() onInputUpdated: EventEmitter<any> = new EventEmitter();

    @ViewChild('input') input: ElementRef<HTMLInputElement>;

    isFocused: boolean = false;

    validationErrors: { [propertyName: string]: ValidationError } = {};

    constructor(private translateService: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.inputValue) {
            if (!changes.inputValue?.isFirstChange()) {
                this.checkInputErrors();
            }
        }
        if (changes.propertyName) {
            if (!changes.propertyName?.isFirstChange()) {
                this.checkInputErrors();
            }
        }
    }

    handleFocus() {
        if (this.disabledInput) return;
        this.isFocused = true;
    }

    handleBlur() {
        this.isFocused = false;
    }

    hasErrorString() {
        if (this.inputHasErrors || this.otherValidationErrors) {
            return true;
        }
        return this.propertyName in this.validationErrors;
    }

    getErrorString() {
        if (this.otherValidationErrors) {
            return this.otherValidationErrors;
        }
        if (this.propertyName in this.validationErrors) {
            const err = this.validationErrors[this.propertyName];
            return this.translateService.instant(err.errors[0], err.params);
        }
        return;
    }

    handleChange() {
        if (this.isNumberInput) {
            const hasAll0 = /^0+$/.test(String(this.inputValue).trim());
            if (isNaN(this.inputValue) || hasAll0) {
                this.inputValue = 0;
                if (this.input) this.input.nativeElement.value = this.inputValue;
            }
        }
        this.onInputUpdated.emit(this.inputValue);
        this.checkInputErrors();
    }

    public checkInputErrors() {
        if (this.validatorFunction) {
            const object = {};
            object[this.propertyName] = this.isNumberInput ? Number(this.inputValue) : this.inputValue;
            const errors = getValidationErrors(this.validatorFunction, object);

            this.validationErrors = errors.length ? mapErrors(errors) : {};
        }
    }
}
